import { CreditCard } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '~/components/ui';
import type { CartItem as OrderItem } from '../types';
import { formatCurrency } from '~/utils';

type OrderSummaryProps = {
  isPlacingOrder?: boolean;
  onPlaceOrder?: () => void;
  items: OrderItem[];
  supplierName: string;
};

export function OrderSummary({
  isPlacingOrder,
  onPlaceOrder,
  items,
  supplierName,
}: OrderSummaryProps) {
  const itemsCount = items.length;
  const organizationName = supplierName;
  const subtotal = items.reduce(
    (acc, item) => acc + item.quantity.value * item.price,
    0
  );

  const { t } = useTranslation('cart');
  return (
    <div className="bg-neut-bg-alt rounded-lg border border-neut-border p-6 sticky top-6 shadow-neut-100">
      <h2 className="text-neut-prim mb-4 font-semibold">
        {t('cart.order_summary')}
      </h2>

      <div className="p-4 bg-prim-50 rounded-lg mb-4">
        <p className="text-xs text-neut-sec mb-1">{t('cart.supplier')}</p>
        <p className="text-sm text-neut-prim font-medium">{organizationName}</p>
        <p className="text-xs text-neut-sec"></p>
      </div>

      <div className="space-y-3 mb-6">
        <div className="flex items-center justify-between text-sm">
          <span className="text-neut-sec font-normal">
            {t('cart.subtotal', { itemsCount: itemsCount })}
          </span>
          <span className="text-neut-prim font-medium">
            {formatCurrency(subtotal.toString())}
          </span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-neut-sec font-normal">
            {t('cart.shipping_fee')}
          </span>
          <span className="text-neut-prim font-medium">TBD</span>
        </div>
        <div className="border-t border-neut-border pt-3 flex items-center justify-between">
          <span className="text-neut-prim font-semibold">
            {t('cart.total')}
          </span>
          <span className="text-xl text-neut-prim font-semibold">
            {formatCurrency(subtotal.toString())}
          </span>
        </div>
      </div>

      <Button onClick={onPlaceOrder}>
        <div className="flex gap-3 items-center justify-center">
          <CreditCard size={18} />
          {isPlacingOrder ? t('cart.placing_order') : t('cart.place_order')}
        </div>
      </Button>

      <p className="text-xs text-neut-500 text-center mt-3">
        {t('cart.order_summary_note')}
      </p>
    </div>
  );
}
